import { render, staticRenderFns } from "./PreserveEventControl.vue?vue&type=template&id=3be18b48&scoped=true"
import script from "./PreserveEventControl.vue?vue&type=script&lang=ts"
export * from "./PreserveEventControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be18b48",
  null
  
)

export default component.exports